import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import { isAdmin } from '../utils/permissions';

export default function RoleRoute({ children, roles, permission }) {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const roleAllowed = Boolean(
    roles
    && (
      roles.includes(user?.role)
      || (roles.includes('admin') && isAdmin(user))
    )
  );
  if (roles && !roleAllowed) {
    return <Navigate to="/" replace />;
  }

  if (permission && !user?.permissions?.[permission]) {
    return <Navigate to="/" replace />;
  }

  return children;
}
